/* @ts-self-types="./iws.d.ts" */
import * as wasm from "./iws_bg.wasm";
import { __wbg_set_wasm } from "./iws_bg.js";

__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    Divide, DivideParam, Hru, Inp, Reach, Slope, Soil, ckmeans_optimal_wasm, ckmeans_wasm, compare_table, main, roundbreaks_wasm
} from "./iws_bg.js";
